/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateServerHeaderForm,
  CreateServerHeaderForm$Outbound,
  CreateServerHeaderForm$outboundSchema,
} from "../components/createserverheaderform.js";

export type CreateRemoteMcpServerHeaderSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateRemoteMcpServerHeaderSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateRemoteMcpServerHeaderSecurity = {
  option1?: CreateRemoteMcpServerHeaderSecurityOption1 | undefined;
  option2?: CreateRemoteMcpServerHeaderSecurityOption2 | undefined;
};

export type CreateRemoteMcpServerHeaderRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createServerHeaderForm: CreateServerHeaderForm;
};

/** @internal */
export type CreateRemoteMcpServerHeaderSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateRemoteMcpServerHeaderSecurityOption1$outboundSchema:
  z.ZodMiniType<
    CreateRemoteMcpServerHeaderSecurityOption1$Outbound,
    CreateRemoteMcpServerHeaderSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createRemoteMcpServerHeaderSecurityOption1ToJSON(
  createRemoteMcpServerHeaderSecurityOption1:
    CreateRemoteMcpServerHeaderSecurityOption1,
): string {
  return JSON.stringify(
    CreateRemoteMcpServerHeaderSecurityOption1$outboundSchema.parse(
      createRemoteMcpServerHeaderSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateRemoteMcpServerHeaderSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateRemoteMcpServerHeaderSecurityOption2$outboundSchema:
  z.ZodMiniType<
    CreateRemoteMcpServerHeaderSecurityOption2$Outbound,
    CreateRemoteMcpServerHeaderSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function createRemoteMcpServerHeaderSecurityOption2ToJSON(
  createRemoteMcpServerHeaderSecurityOption2:
    CreateRemoteMcpServerHeaderSecurityOption2,
): string {
  return JSON.stringify(
    CreateRemoteMcpServerHeaderSecurityOption2$outboundSchema.parse(
      createRemoteMcpServerHeaderSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateRemoteMcpServerHeaderSecurity$Outbound = {
  Option1?: CreateRemoteMcpServerHeaderSecurityOption1$Outbound | undefined;
  Option2?: CreateRemoteMcpServerHeaderSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateRemoteMcpServerHeaderSecurity$outboundSchema: z.ZodMiniType<
  CreateRemoteMcpServerHeaderSecurity$Outbound,
  CreateRemoteMcpServerHeaderSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateRemoteMcpServerHeaderSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateRemoteMcpServerHeaderSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createRemoteMcpServerHeaderSecurityToJSON(
  createRemoteMcpServerHeaderSecurity: CreateRemoteMcpServerHeaderSecurity,
): string {
  return JSON.stringify(
    CreateRemoteMcpServerHeaderSecurity$outboundSchema.parse(
      createRemoteMcpServerHeaderSecurity,
    ),
  );
}

/** @internal */
export type CreateRemoteMcpServerHeaderRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateServerHeaderForm: CreateServerHeaderForm$Outbound;
};

/** @internal */
export const CreateRemoteMcpServerHeaderRequest$outboundSchema: z.ZodMiniType<
  CreateRemoteMcpServerHeaderRequest$Outbound,
  CreateRemoteMcpServerHeaderRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createServerHeaderForm: CreateServerHeaderForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createServerHeaderForm: "CreateServerHeaderForm",
    });
  }),
);

export function createRemoteMcpServerHeaderRequestToJSON(
  createRemoteMcpServerHeaderRequest: CreateRemoteMcpServerHeaderRequest,
): string {
  return JSON.stringify(
    CreateRemoteMcpServerHeaderRequest$outboundSchema.parse(
      createRemoteMcpServerHeaderRequest,
    ),
  );
}
